<template>
  <VModal ref="modal" @modal:hidden="$emit('close')" disable-backdrop-click>
    <div class="mx-auto w-full max-w-lg">
      <BaseCard>
        <BaseCardBody>
          <div class="space-y-1 mb-8">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              You have unsaved changes. Would you like to save before leave?
            </h3>
            <!-- <p class="max-w-2xl text-sm text-gray-500">

            </p> -->
          </div>
        </BaseCardBody>
        <BaseCardFooter>
          <div class="flex space-x-2">
            <BaseButton primary @click="handleConfirm"> Yes, save and leave </BaseButton>
            <BaseButton type="button" primary outline @click="handleDeny"> Just leave </BaseButton>
          </div>
        </BaseCardFooter>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
export default {
  methods: {
    handleConfirm() {
      this.$emit('confirm');
      this.$refs.modal.close();
    },
    handleDeny() {
      this.$emit('deny');
      this.$refs.modal.close();
    },
  },
};
</script>
